// Module
var code = "<div ng-if=\"$ctrl.procedure\"> <procedure-editor procedure=\"$ctrl.procedure\" read-only=\"true\" is-public-view=\"true\"> </procedure-editor> </div> <error-message ng-if=\"$ctrl.unauthorized\" message=\"'You are not authorized to view this SOP'\"></error-message> ";
// Exports
export default code;